interface LogoMetadata {
  src: string;
  alt: string;
  width: number;
  height: number;
}

export const MP_LOGO_METADATA: LogoMetadata = Object.freeze({
  src: require(`../../images/logo-slate.svg`),
  alt: `Mixpanel logo`,
  width: 126,
  height: 42,
});

export const MP2023_LOGO_METADATA: LogoMetadata = Object.freeze({
  src: require(`../../images/mp2023-logo.svg`),
  alt: `Mixpanel logo`,
  width: 126,
  height: 42,
});

export const COMPANY_SIZE_OPTIONS = [
  `1`,
  `2–10`,
  `11–50`,
  `51–200`,
  `201–500`,
  `501–1,000`,
  `1,001–5,000`,
  `5,001–10,000`,
  `More than 10,000`,
];

export const DEPARTMENT_OPTIONS = [
  `Analytics`,
  `Data`,
  `Design / UX`,
  `Engineering`,
  `Executive`,
  `Growth`,
  `Marketing`,
  `Product`,
  `Other`,
];

export const MAU_SIZE_OPTIONS = [`Less than 1000`, `1000–25000`, `25000–100000`, `More than 100000`];

export const enum Step {
  UserCredentials = 0,
  ExtraDetails = 1,
}
